import { Container, Typography } from "@mui/material";
import VerticalTabs from '../../component/location/tabsCompo'
import { useLanguage } from '../../i18n/LanguageContext';

const content = {
    en: { title: "Our Location", intro: "Visit us at one of our offices in the United States and Saudi Arabia." },
    ar: { title: "موقعنا", intro: "تفضل بزيارتنا في أحد مكاتبنا في الولايات المتحدة والمملكة العربية السعودية." },
};
const Location = () => {
    const { lang } = useLanguage();
    const c = content[lang];
    return (
        <>
            <Container maxWidth="lg" align="center" className="locationSection" id="ourlocationSection">
                <Typography variant="h3" gutterBottom >
                    {c.title}
                </Typography>
                <Typography variant="subtitle1" gutterBottom >
                    {c.intro}
                </Typography>
            </Container>
            <VerticalTabs/>
        </>
    )
}
export default Location;